
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"#fff","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.8","cy":"64","r":"14.8"}},[_c('animate',{attrs:{"attributeName":"opacity","begin":".1","calcMode":"linear","dur":"1.2s","repeatCount":"indefinite","values":"0;1;0"}})]),_c('circle',{attrs:{"cx":"64","cy":"64","r":"14.8"}},[_c('animate',{attrs:{"attributeName":"opacity","begin":".2","calcMode":"linear","dur":"1.2s","repeatCount":"indefinite","values":"0;1;0"}})]),_c('circle',{attrs:{"cx":"113.2","cy":"64","r":"14.8"}},[_c('animate',{attrs:{"attributeName":"opacity","begin":".3","calcMode":"linear","dur":"1.2s","repeatCount":"indefinite","values":"0;1;0"}})])])
          )
        }
      }
    